var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3996 5.2001C7.52771 5.2001 5.1996 7.52822 5.1996 10.4001C5.1996 13.272 7.52771 15.6001 10.3996 15.6001C13.2715 15.6001 15.5996 13.272 15.5996 10.4001C15.5996 7.52822 13.2715 5.2001 10.3996 5.2001ZM2.59961 10.4001C2.59961 6.09228 6.09178 2.6001 10.3996 2.6001C14.7074 2.6001 18.1996 6.09228 18.1996 10.4001C18.1996 12.0847 17.6655 13.6445 16.7575 14.9196L23.0188 21.1809C23.5265 21.6885 23.5265 22.5117 23.0188 23.0193C22.5111 23.527 21.688 23.527 21.1803 23.0193L14.9191 16.7581C13.644 17.6661 12.0842 18.2001 10.3996 18.2001C6.09178 18.2001 2.59961 14.7079 2.59961 10.4001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.ee4b3ccf381a2edf405d59ddcd3dd5fd.svg";
export { ForwardRef as ReactComponent };